import { makeStyles, useTheme } from '@material-ui/core';
import classNames from 'classnames';
import { useUpdateSkillMutation, useGetLevelOfSkillsQuery } from 'utils/wemble-api';
import { haptic } from 'utils/haptics';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-block',
    padding: '4px 0',
  },
  circles: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  circle: {
    height: 16,
    width: 16,
    marginLeft: 6,
    borderRadius: '50%',
  },
  circle_compact: {
    height: 12,
    width: 12,
    marginLeft: 3,
  },
  circle_hover: {
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none' as const,
    userSelect: 'none' as const,
    cursor: 'pointer',
    '@media (hover: hover)': {
      '&:hover': {
        opacity: 0.7,
      },
    },
  },
  circle_non_changeable: {
    cursor: 'default'
  },
  tooltip: {
    // Use display: none (not visibility: hidden) so the absolutely-positioned tooltip
    // doesn't contribute to layout when hidden. Long level names + many circles per row
    // (e.g. Crowell with 6 levels and ~30-char names) otherwise push the document's
    // scroll area past the viewport on mobile, causing phantom horizontal scroll.
    display: 'none',
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: "#222222AA",
    color: 'white',
    textAlign: 'center',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    zIndex: 1,
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
    fontSize: 12,
  },
  circleContainer: {
    position: 'relative',
    display: 'inline-block',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -8,
      bottom: -8,
      left: -4,
      right: -4,
    },
    '&:hover $tooltip': {
      display: 'block',
    },
  },

}));

const CompetenceAverageSkillLevel = ({
  skill = -1,
  changeable = false,
  userID = null,
  skillID,
}: {
  skill: number | undefined;
  changeable?: boolean;
  userID?: string | null;
  skillID?: string | null;
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { data: levelOfSkills } = useGetLevelOfSkillsQuery();
  const [updateSkill] = useUpdateSkillMutation();

  return (
    <div className={classes.root}>
      <div className={classes.circles}>
        {[...(levelOfSkills ?? [])]
          .sort((a, b) => (a.level ?? 0) - (b.level ?? 0))
          .map((levelOfSkill, index) => (
            <div
              className={classNames(classes.circleContainer, classes.circle, (levelOfSkills?.length ?? 0) > 5 && classes.circle_compact, changeable ? classes.circle_hover : classes.circle_non_changeable)}
              style={
                Math.round(skill) < (levelOfSkill.level ?? 0)
                  ? { backgroundColor: theme.palette.gray.g9 }
                  : {
                    backgroundColor: skill === 0 ? theme.palette.green.g4 : theme.palette.blue.b2,
                  }
              }
              key={index}
              onClick={(e) => {
                e.stopPropagation()
                console.log('update skill', changeable, userID, skillID, levelOfSkill._id);
                if (changeable && userID && skillID && levelOfSkill._id) {
                  haptic('medium');
                  // TODO Implement redux function for changing skill
                  console.log(levelOfSkill);
                  console.log({
                    _id: skillID,
                    level: levelOfSkill._id,
                  });
                  updateSkill({ id: skillID, skillUpdateParams: { levelOfSkillId: levelOfSkill.level == skill ? undefined : levelOfSkill._id } });
                }
              }}
            >
              <div className={classes.tooltip}>{levelOfSkill.name}</div>

            </div>

          ))}
      </div>
    </div>
  );
};

export default CompetenceAverageSkillLevel;
